module.exports = __webpack_public_path__ + "img/indexBanner.c08458de.png";